export const HALL_OPTIONS = [
  { key: "Nova",                    capacity: 250, type: "single" },
  { key: "Titan",                   capacity: 250, type: "single" },
  { key: "Lunar",                   capacity: 250, type: "single" },
  { key: "Eclipse",                 capacity: 250, type: "single" },
  { key: "Nova + Titan",            capacity: 500, type: "combo"  },
  { key: "Titan + Lunar",           capacity: 500, type: "combo"  },
  { key: "Lunar + Eclipse",         capacity: 500, type: "combo"  },
  { key: "Nova + Titan + Lunar",    capacity: 750, type: "combo"  },
  { key: "Titan + Lunar + Eclipse", capacity: 750, type: "combo"  },
  { key: "Full Hall",               capacity: 900, type: "combo"  },
] as const;

export type HallKey = typeof HALL_OPTIONS[number]["key"];

export const DAY_TYPES = ["Mon-Thu", "Fri", "Sat", "Sun", "Holiday"] as const;
export type DayType = typeof DAY_TYPES[number];

export const TIME_SLOTS = [
  { value: "AM",       label: "Morning  ·  8:00 AM – 3:00 PM",  timeRange: "8:00 AM – 3:00 PM",  startTime: "08:00", endTime: "15:00" },
  { value: "PM",       label: "Evening  ·  6:00 PM – 1:00 AM",  timeRange: "6:00 PM – 1:00 AM",  startTime: "18:00", endTime: "01:00" },
  { value: "FULL_DAY", label: "Full Day  ·  8:00 AM – 1:00 AM", timeRange: "8:00 AM – 1:00 AM",  startTime: "08:00", endTime: "01:00" },
] as const;

export type TimeSlot = typeof TIME_SLOTS[number]["value"];

/** Sentinel value meaning "applies to every hall" */
export const ALL_HALLS = "all";
